var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 21 27",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5 24C1.50237 24.7949 1.81921 25.5566 2.3813 26.1187C2.9434 26.6808 3.70508 26.9976 4.5 27H16.5C17.2949 26.9976 18.0566 26.6808 18.6187 26.1187C19.1808 25.5566 19.4976 24.7949 19.5 24V6H1.5V24ZM5.19 13.32L7.305 11.2L10.5 14.385L13.68 11.205L15.8 13.32L12.615 16.5L15.795 19.68L13.68 21.8L10.5 18.615L7.32 21.8L5.2 19.68L8.385 16.5L5.19 13.32ZM15.75 1.5L14.25 0H6.75L5.25 1.5H0V4.5H21V1.5H15.75Z",
    fill: "#486581"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_15"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.8050b823e726fa6b22374c9b4b164dc3.svg";
export { ForwardRef as ReactComponent };